import axios from 'axios'

/**
 * 公共方法类
 * @description        基于公司后端服务对geoserver发布的地图服务进行分析
 * @author             XiongXiao
 * @Date               2023-02-14
 * @class
 * @agentDescription
 *  目前调用前需要配置代理服务vue3项目在vue.config.js文件添加如下代理：
 *  '/kjfx': {
        target: 'http://192.168.2.224:12126/zgis',
        changeOrigin: true,
        pathRewrite: {
          '^/kjfx': '/'
        }
    }
 */

class GeoQryBySvr
{
  constructor(opts = {})
  {
    this.opts = opts
  }
  
  /**
 * 属性查看
 * @method
 * @param        {Object}        params                        参数对象
 * @param        {Array}         params.layers                 图层集合
 * @param        {String}        params.layers[0].url          图层url 示例:'http://192.168.2.225:8089/geoserver'
 * @param        {String}        params.layers[0].layer        图层layer 示例：'HTW:河北县级行政区'
 * @param        {Array}         params.coordinates            点坐标 示例：[115.64964,38.52631]
 * @param        {String}        params.crs                    点坐标系 示例：'EPSG:4326'
 * @return       {Promise}
 * @description                                                layers参数为一个数组，可传多个包含图层url和layer的对象
 * 参数示例：{"layers":[{"url":"http://192.168.2.225:8089/geoserver","layer":"HTW:河北县级行政区"}],"coordinates": [115.64964,38.52631],"crs":"EPSG:4326"}
 */
  static getAttBySvr(params)
  {
    params.scale = params.scale ? params.scale : 0.0008
    params.layers = params.layers.map(i =>
    {
      return { url: this.makeUrl(i.url), layer: i.layer }
    })
    return axios.post('/kjfx/getAttribute', params)
  }

  /**
   * 属性查询
   * @param        {Object}        evt             参数对象
   * @param        {String}        evt.url         图层地址 示例：'http://192.168.2.225:8089/geoserver'
   * @param        {String}        evt.layer       图层layer 示例：'HTW:河北县级行政区'
   * @param        {String}        evt.exp         查询条件 示例：'1=1' 注：查询条件为1=1时，默认查询所有
   * @return       {Promise}
   * @description                                  该服务只支持单个图层进行查询，查询条件为该图层某个字段的模糊查询。
   * 参数示例：{url: 'http://192.168.2.225:8089/geoserver', layer: 'HTW:河北县级行政区', exp: '1=1'}
   */
  static qryAttBySvr(evt)
  {
    evt.url = this.makeUrl(evt.url)
    let params = new URLSearchParams()
    params.append('url', evt.url)
    params.append('layer', evt.layer)
    params.append('exp', evt.exp)
    return axios.post(`/kjfx/queryAttribute?url=${evt.url}&layer=${evt.layer}&exp=${evt.exp}`)
  }

  /**
   * 空间分析
   * @param         {Object}        params                        参数对象
   * @param         {Array}         params.layers                 需要进行分析的图层集合数组
   * @param         {String}        params.layers[0].url          图层地址
   * @param         {String}        params.layers[0].layer        图层layer
   * @param         {Object}        params.geometry               需要进行分析的范围图形
   * @param         {String}        params.geometry.type          图形类型 点：Point,线：LineString,单个面：Polygon,多个面：MultiPolygon
   * @param         {Arrry}         params.geometry.coordinates   图形坐标
   * @param         {Object}        params.properties             图形坐标系
   * @param         {String}        params.properties.crs         服务坐标系
   * @param         {String}        params.properties.outSr       输出图形坐标系
   * @return       {Promise}
   * @description   坐标示例：
   * 点：{type: 'Point', coordinates: [116.15501, 38.20084]
   * 线：{type: 'LineString', coordinates: [[[117.14996,42.37427],[117.80365,42.04468]]]} 注：第一个点坐标不能和最后一个点坐标相同
   * 单个面：{type: 'Polygon', coordinates: [[[117.14996,42.37427][117.80365,42.04468],[117.79816,41.53381],[117.14996,42.37427]]]} 注：一个面点的坐标最少为四个，且第一个点坐标需和最后一个点坐标一致
   * 多个面：{type: 'MultiPolygon', coordinates:
   * [[[[117.07306,42.29187],
     [117.93549,42.02820],
     [117.64984,41.82495],
     [117.46307,41.88538],
     [117.07306,42.29187]]], 这为一个面，下面的为另一个面
     [[[115.70526,41.13281],
     [115.87555,40.69885],
     [115.62286,40.67139],
     [115.50751,40.77576],
     [115.70526,41.13281]]]]}
     参数示例：{"layers":[{"url":"http://192.168.2.225:8089/geoserver","layer":"HTW:河北县级行政区"}],"geometry":{"type":"Point","coordinates":[116.15501,38.20084]},"properties: { crs: 'EPSG:4326', outSr: 'EPSG:4326' }"}
   */
  static spatialAnalyse(params)
  {
    params.layers = params.layers.map(i =>
    {
      return { url: this.makeUrl(i.url), layer: i.layer, name: i.name }
    })
    return axios.post('/kjfx/spatialAnalyse', params)
  }

  /**
   * 构造参数URL
   * @param             {String}      url                 图层地址
   * @returns           {Promise}
   */
  static makeUrl(url)
  {
    return url.split('geoserver').length === 1 ? url : url.split('geoserver')[0] + 'geoserver'
  }
}
export default GeoQryBySvr



// WEBPACK FOOTER //
// ./src/plugins/app/assembly/kyxxyzt/GeoQryBySvr.js